<template>
  <div class="step-success text-center">
    <div class="success-icon-wrapper mx-auto mb-4">
      <img src="@/assets/img/nganluong/icon-success.svg" alt="Thành công" />
    </div>

    <h2 class="success-title fw-bold mb-3">Hợp đồng đã được ký!</h2>

    <p class="success-desc">
      Cảm ơn Quý khách đã xác nhận. Hợp đồng dịch vụ đã chính thức có hiệu lực. Quý khách có thể
      tiếp tục sử dụng dịch vụ ngay bây giờ.
    </p>

    <!-- Fake footer -->
    <div class="popup-footer">
      <b-button variant="success" class="footer-btn w-100" @click="$emit('close')">
        Hoàn tất
      </b-button>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'StepSuccess',
  }
</script>

<style scoped>
  .step-success {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 8px 0;
  }

  .success-icon-wrapper {
    width: 72px;
    height: 72px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .success-icon-wrapper img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }

  .success-title {
    font-size: 20px;
    color: #222;
  }

  .success-desc {
    font-size: 15px;
    color: #555;
    line-height: 1.6;
    max-width: 340px;
    margin: 0 auto;
  }

  /* Fake footer */
  .popup-footer {
    display: flex;
    justify-content: center;
    padding: 20px 0 0;
    border-top: 1px solid #e9ecef;
    margin-top: 24px;
    width: 100%;
  }

  .footer-btn {
    font-weight: 600;
    border-radius: 8px;
    padding: 10px 20px;
    font-size: 16px;
  }
</style>
